import { inject } from '@angular/core';
import { Routes } from '@angular/router';

import { ROUTE_NAMES } from '@constants';
import { CommunityService } from '@services';
import { firstValueFrom } from 'rxjs';
import {
  i18nResolver,
  userBeanWithFunctionsCheckResolver,
} from 'src/app/core/resolvers';

export const communityRoutes: Routes = [
  {
    path: 'community',
    title: 'WEB_COMMUNITY_SETTINGS',
    resolve: {
      agorai18n: i18nResolver,
      userBean: userBeanWithFunctionsCheckResolver,
      resource: () => firstValueFrom(inject(CommunityService).getCommunity()),
    },
    loadComponent: () =>
      import('./pages/community.component').then((m) => m.CommunityComponent),
    data: { navigationRoute: ROUTE_NAMES.COMMUNITY },
  },
];
